import { ICS2InformationExchangeMessages } from 'store/declarations/eu/ics2/ICS2InformationExchangeMessages';
import { ICS2Notification } from 'store/declarations/eu/ics2/ics2-notification';
import IE3Q01 from './IE3Q01/IE3Q01';
import IE3R08 from './IE3R08/IE3R08';
import RawData from '../../RawData';

type Props = {
    latestNotification?: ICS2Notification;
};

/**
 * IE3Q02/IE3Q03 never reach here: referral requests are filtered out of the drawer entirely and
 * answered on the Customs Requests tab. See `ICS2_CUSTOMS_REQUEST_MESSAGE_TYPES`.
 */
const Ics2ActionRequiredNotification = ({ latestNotification }: Props) => {
    const notification = latestNotification?.notification;
    const rawMessage = latestNotification?.rawMessage ?? '';

    switch (latestNotification?.messageType) {
        case ICS2InformationExchangeMessages.IE3Q01:
            return <IE3Q01 notification={notification} />;
        case ICS2InformationExchangeMessages.IE3R08:
            return <IE3R08 notification={notification} />;
        default:
            return <RawData notification={latestNotification} rawMessage={rawMessage} />;
    }
};

export default Ics2ActionRequiredNotification;
